// Preprod - 231 Sununucu
//const UYGULAMA_BASE_URL = "http://172.72.239.231/EBelgeEntegrasyon/api";

// Preprod - 217 Büyükçekmece Sunucu
// const UYGULAMA_BASE_URL = "http://192.168.30.217/EBelgeEntegrasyon/api";

// Preprod - 196 Karesi Sunucu
//const UYGULAMA_BASE_URL = "http://172.72.239.196/EBelgeEntegrasyon/api";

// Preprod - 174 Sancaktepe Sunucu
// const UYGULAMA_BASE_URL = "http://172.72.239.174/EBelgeEntegrasyon/api";

// Preprod - 185 Sultangazi Sunucu
// const UYGULAMA_BASE_URL = "http://172.72.239.185/EBelgeEntegrasyon/api"; 

// Dev Ortamı
// const UYGULAMA_BASE_URL = "http://localhost:44330/api"

// Prod Sunucu
const UYGULAMA_BASE_URL = window.location.origin + "/EBelgeEntegrasyon/api"


const HARC_BASE_URL = UYGULAMA_BASE_URL + "/Harc";
const RAPOR_BASE_URL = UYGULAMA_BASE_URL + "/Rapor";
const RUHSAT_BASE_URL = UYGULAMA_BASE_URL + "/Ruhsat";
const MUELLIF_BASE_URL = UYGULAMA_BASE_URL + "/Muellif";
const HARC_HESAP_BASE_URL = UYGULAMA_BASE_URL + "/HarcHesap";
const ESLESMEYEN_YIBF_BASE_URL = UYGULAMA_BASE_URL + "/EslesmeyenYibf";
const EXCEL_URL = UYGULAMA_BASE_URL + "/Excel";
const KULLANICI_URL = UYGULAMA_BASE_URL + "/Kullanici";
const BASVURU_BASE_URL = UYGULAMA_BASE_URL + "/Basvuru";
const BELGE_URL = UYGULAMA_BASE_URL + "/Belge";
const BASE_URL = UYGULAMA_BASE_URL + "/Base";
const PARENT_BASVURU_URL = UYGULAMA_BASE_URL + "/ParentBasvuru";
const STATE_SERVER_URL = UYGULAMA_BASE_URL + "/StateServer";
const EMLAK_BEYAN_URL = UYGULAMA_BASE_URL + "/EmlakBeyan";
const BASVURU_OZELLIK_URL = UYGULAMA_BASE_URL + "/BasvuruOzellik";
const PARSEL_BASE_URL = UYGULAMA_BASE_URL + "/Parsel";
const IMZA_BASE_URL = UYGULAMA_BASE_URL + "/Imza";

export const BELGE_GRUBU_VE_TURU_BASVURU_SAYILARI = RAPOR_BASE_URL + "/BelgeGrubunaGoreBasvuruSayisiSorgula";
export const BELGE_TURU_VE_DURUMUNA_GORE_BASVURU_LISTESI = RAPOR_BASE_URL + "/BelgeTuruneGoreBasvuruListesiSorgula";
export const BELGE_GRUBUNA_GORE_RESMI_RUHSAT_SAYILARI = RAPOR_BASE_URL + "/BelgeGrubunaGoreResmiBasvuruSayisiSorgula"
export const BELGE_TURU_VE_DURUMUNA_GORE_RESMI_BASVURU_LISTESI = RAPOR_BASE_URL + "/BelgeTuruneGoreResmiBasvuruListesiSorgula";
export const BASVURU_ANAYA_GORE_BASVURU_LISTESI = RAPOR_BASE_URL + "/BasvuruAnayaGoreBasvuruListesiSorgula";
export const BASVURU_ANA_DURUM_LISTESI = RAPOR_BASE_URL + "/BasvuruAnaOzetListesiGetir";
export const BELGE_TURU_LISTESI = RAPOR_BASE_URL + "/BelgeTurleriniSorgula";
export const ILCE_LISTESI = RAPOR_BASE_URL + "/IlceSorgula";
export const MAHALLE_LISTESI = RAPOR_BASE_URL + "/MahalleSorgula";
export const BASVURU_ANA_DURUM_TURLERI_LISTESI = RAPOR_BASE_URL + "/BasvuruAnaDurumTurleriniSorgula";
export const BASVURU_DENETIM_SONUC_KRITERI_LISTESI = RAPOR_BASE_URL + "/DenetimSonucKriteriSorgula";
export const BASVURU_DENETIM_SONUC_KRITERI_GUNCELLE = RAPOR_BASE_URL + "/DenetimSonucKriteriGuncelle";
export const BASVURU_STATE_ZAMANLARI_LISTELE = RAPOR_BASE_URL + "/BasvuruStateZamanlariListele"
export const YIBF_ESLESME_TALEP_LISTESI = RAPOR_BASE_URL + "/YibfEslesmeTalebiSorgulaByUserId";
export const HARC_TUR_TANIM_LISTESI = HARC_HESAP_BASE_URL + "/TurTanimListesiGetir";
export const HARC_TUR_AKTIF_TARIFE_GETIR = HARC_HESAP_BASE_URL + "/TurVeServiseGoreAktifTarifeGetir";
export const BASVURU_TAHAKKUK_OLUSTUR = HARC_HESAP_BASE_URL + "/BasvuruTahakkukOlustur";
export const BASVURU_HARC_LISTESI = HARC_HESAP_BASE_URL + "/BasvuruHarclariSorgula";
export const HARC_DENETIM_KRITERI_LISTESI = HARC_BASE_URL + "/BasvuruHarcKriteriSorgula";
export const HARC_DENETIM_KRITERI_GUNCELLE = HARC_BASE_URL + "/BasvuruHarcKriteriGuncelle";
export const GET_PARAMETRE_DEGER = UYGULAMA_BASE_URL + "/Base/GetParameter"
export const RUHSAT_SORU_CEVAP_LISTESI = RUHSAT_BASE_URL + "/RuhsatSoruCevapListesi";
export const RUHSAT_SORU_CEVAP_GUNCELLE = RUHSAT_BASE_URL + "/RuhsatSoruCevapGuncelle";
export const TAPU_MAHALLE = RUHSAT_BASE_URL + "/TapuMahalleSorgula";
export const ADA_PARSEL = RUHSAT_BASE_URL + "/AdaParselSorgula";
export const EB_ISKAN_MUELLIF = RUHSAT_BASE_URL + "/EbIskanMuellifSorgula";
export const EB_YIBF_ISIN_DURUMU = RUHSAT_BASE_URL + "/EbYibfIsinDurumuSorgula";
export const YIBF_ESLESMEME_SEBEBI = ESLESMEYEN_YIBF_BASE_URL + "/YibfEslesmemeSebebi";
export const ESLESMEYEN_YIBF_GUNCELLE = ESLESMEYEN_YIBF_BASE_URL + "/EslesmeyenYibfGuncelle";
export const MUELLIF_SECIM_LISTESI = MUELLIF_BASE_URL + "/MuellifSecimListesi";
export const BASVURU_MUELLIF_GUNCELLE = MUELLIF_BASE_URL + "/BasvuruMuellifGuncelle";
export const BELGE_GRUBUNA_GORE_ALT_SUREC_BASVURU_SAYILARI = RAPOR_BASE_URL + "/BelgeGrubunaGoreAltSurecBasvuruSayisiSorgula";
export const ALT_SUREC_VE_DURUMUNA_GORE_BASVURU_LISTESI = RAPOR_BASE_URL + "/AltSureceGoreBasvuruListesiSorgula";
export const KULLANICI_EKLE = BASE_URL + "/KullaniciEkle";
export const GET_HASH_KEY = BASE_URL + "/GetHashKey";
export const YIBF_EXCEL_UPLOAD = EXCEL_URL + "/YibfExcelUpload";
export const RAPORTOR_SECIM_LISTESI = KULLANICI_URL + "/RaportorSecimListesi";
export const CREATE_BASVURU_WITH_ALTSUREC = BASVURU_BASE_URL + "/CreateBasvuruWithAltSurec";
export const ISIM_DEGISIKLIK_KONU_SORGULA = RUHSAT_BASE_URL + "/IsimDegisiklikKonuSorgula";
export const BASVURU_ISIM_DEGISIKLIK_KONU_GUNCELLE = PARENT_BASVURU_URL + "/BasvuruIsimDegisiklikKonuGuncelle";
export const BASVURU_ISIM_DEGISIKLIK_KONU_SORGULA = PARENT_BASVURU_URL + "/BasvuruIsimDegisiklikKonuSorgula";
export const CREATE_BASVURU_WITH_YIBFNO = BASVURU_BASE_URL + "/YibfNoIleBasvuruOlustur";
export const RAPORTORLERI_GUNCELLE = BASVURU_BASE_URL + "/RaportorleriGuncelle";
export const ADD_ATAEVENT = BASVURU_BASE_URL + "/AtaEventEkle";
export const IMZACILARI_LISTELE = BELGE_URL + "/ImzacilariListele";
export const BASVURU_STATE_CONNECTOR = BASVURU_BASE_URL + "/GetBasvuruStateConnector";
export const BASVURU_IADE_KURAL_LISTESI = BASVURU_BASE_URL + "/BasvuruIadeKuralSorgula";
export const KURALA_GORE_IADE_EVENT_EKLE = BASVURU_BASE_URL + "/KuralaGoreIadeEventEkle";
export const RUHSAT_TIPI_SORGULA = RUHSAT_BASE_URL + "/RuhsatTipiSorgula";
export const BASVURU_RUHSAT_TIPI_GUNCELLE = PARENT_BASVURU_URL + "/ParentBasvuruRuhsatTipiGuncelle";
export const BASVURU_RUHSAT_TIPI_SORGULA = PARENT_BASVURU_URL + "/ParentBasvuruRuhsatTipiSorgula";
export const ISKAN_PARENT_BASVURU_OLUSTUR= PARENT_BASVURU_URL + "/IskanParentBasvuruOlustur";
export const BASVURU_GECMIS_GETIR = BASVURU_BASE_URL + "/BasvuruGecmisGetir";
export const SON_ISLEM_SIL = STATE_SERVER_URL + "/SonİslemKaydiniSil";
export const ASAMA_PERFORMANS_RAPOR_SUREC_LISTESI_GETIR = RAPOR_BASE_URL + "/AsamaPerformansRaporSurecListesi";
export const ASAMA_PERFORMANS_RAPOR_SORGULA = RAPOR_BASE_URL + "/AsamaPerformansRaporSorgula";
export const BELGE_VE_IMZALARI_LISTELE = BELGE_URL + "/GetFilesWithSigners";
export const EB_EVENT_EKLE = BASVURU_BASE_URL + "/EbEventEkle";
export const CREATE_BASVURU_WITH_ALTSUREC_LIST = BASVURU_BASE_URL + "/CreateBasvuruWithAltSurecList";
export const SORUMLU_SECIM_LISTESI = KULLANICI_URL + "/SorumluSecimListesi";
export const SORUMLU_GUNCELLE = BASVURU_BASE_URL + "/SorumluGuncelle";
export const MUELLIF_GUNCELLE_LISTESI = MUELLIF_BASE_URL + "/MuellifGuncelleListesi";
export const MUELLIF_KULLANICI_LISTESI =  MUELLIF_BASE_URL + "/MuellifKullaniciListesi";
export const BASVURU_MUELLIF_BURO_DEGISTIR=  MUELLIF_BASE_URL +  "/BasvuruMuellifBuroDegistir";
export const ILISKILI_BASVURU_GECMISI_GETIR =  BASVURU_BASE_URL +  "/IliskiliBasvuruGecmisGetir";
export const BASVURU_OLUSTUR = BASVURU_BASE_URL + "/BasvuruOlustur";
export const GET_EB_BASVURU_OZELLIK_KURAL = BASVURU_OZELLIK_URL + "/GetEbBasvuruOzellikKural";
export const SET_EB_BASVURU_OZELLIK = BASVURU_OZELLIK_URL + "/SetEbBasvuruOzellik";
export const BASVURU_SILINEN_ISLEM_KAYDINI_GETIR = BASVURU_BASE_URL + "/BasvuruSilinenIslemKaydiniGetir";
export const SESSION_ILE_SICIL_SORGULA = RUHSAT_BASE_URL + "/SessionIleSicilSorgula";
export const EMLAK_BEYAN_SORGULA = EMLAK_BEYAN_URL + "/EmlakBeyanSorgula";
export const PARSEL_SORGULA = EMLAK_BEYAN_URL + "/ParselSorgula";
export const EB_BASVURU_OZELLIK_BY_MULTIROWT = BASVURU_OZELLIK_URL + '/GetEbBasvuruOzellikByMultiRowT';
export const IDARI_MAHALLE_SORGULA = PARSEL_BASE_URL + '/IdariMahalleSorgula';
export const GET_IMZACI_SECIM_KURAL = IMZA_BASE_URL + '/GetImzaciList';
export const CREATE_BASVURU_IMZACI_LIST = IMZA_BASE_URL + '/CreateBasvuruImzaciList';
